// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as SuccessWithNoContentApiModel from "../api-model/SuccessWithNoContentApiModel.bs.js";

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(SuccessWithNoContentApiModel.t_decode(json), "SuccessWithNoContentEntityMapper.res");
  return {
          title: res.title,
          message: res.message
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
